import { Dialog, IconButton } from "@mui/material";
import { FileText, ScrollText, X } from "lucide-react";
import "../../components/Common/FormModal.css";
import "../../components/Common/ContentPreviewModal.css";

const TermsAndConditionPreviewModal = ({ open, handleClose, contentData }) => {
  if (!contentData) return null;

  const title = contentData.title || "Terms & conditions";
  const html = contentData.content || "";
  const hasContent = Boolean(html && String(html).trim());

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
      PaperProps={{ className: "fm-dialog cpm-dialog" }}
    >
      <div className="fm-header">
        <span className="fm-header-icon" aria-hidden>
          <ScrollText size={20} strokeWidth={2} />
        </span>
        <div className="fm-header-copy">
          <h2>{title}</h2>
          <p>Read-only preview of the published terms content.</p>
        </div>
        <IconButton
          className="fm-close"
          onClick={handleClose}
          aria-label="Close"
          size="small"
        >
          <X size={18} strokeWidth={2} />
        </IconButton>
      </div>

      <div className="fm-body">
        <div className={`cpm-surface${hasContent ? "" : " is-empty"}`}>
          {hasContent ? (
            <div dangerouslySetInnerHTML={{ __html: html }} />
          ) : (
            <div className="cpm-empty">
              <FileText size={28} strokeWidth={1.6} aria-hidden />
              <p>No content available for these terms.</p>
            </div>
          )}
        </div>
      </div>

      <div className="fm-footer">
        <button type="button" className="fm-btn is-primary" onClick={handleClose}>
          Close
        </button>
      </div>
    </Dialog>
  );
};

export default TermsAndConditionPreviewModal;
